import type { Category } from '~/@types/redux';
import { CATEGORY_DETAILS } from '~/pages/Home/constants';

const getCategoryName = (id: number) => {
  const category = CATEGORY_DETAILS?.find((category) => category?.id === id);
  return category?.name;
};

const isCategoryVerified = (category: Category) => {
  // If there are no gutter items, then the category can't be verified
  if (category?.navigationGutterItems?.length === 0) return false;

  // If every gutter item is verified, then the category is verified
  return category?.navigationGutterItems?.every(isGutterItemVerified) ?? false;
};

const isGutterItemVerified = (gutterItem) => {
  // If there are no children for this item
  if (gutterItem?.gutterItemChildren?.length === 0)
    // If the item has a ruleResultId of 0, then this is a shadow rule, and we should just say that it's been verified
    //   otherwise, return the value of if the Underwriter has verified this item.
    return (
      gutterItem?.ruleResultId === 0 ||
      (gutterItem?.isUnderwriterVerified ?? false)
    );

  // Recursively call for every child to see if they are valid as well.
  return gutterItem?.gutterItemChildren?.every(isGutterItemVerified);
};

const generateRoleSpecificDataTrack = (
  allCategories: Category[],
  isUnderwriter: boolean,
) => {
  CATEGORY_DETAILS.forEach((category) => {
    const currentCategory = allCategories?.find(
      (item) => item?.navigationCategoryId === category?.id,
    );

    const categoryName = category.name
      .toLowerCase()
      .replaceAll(/\s+/g, '')
      .replaceAll('&', '');
    const user = isUnderwriter ? 'uw' : 'broker';
    globalThis.dataTracking[user] = globalThis.dataTracking[user] || {};
    globalThis.dataTracking[user][`${categoryName}complete`] =
      isCategoryVerified(currentCategory);
  });
};

export { getCategoryName, generateRoleSpecificDataTrack };
